import { render, staticRenderFns } from "./CustomerPropertiesSeparateList.vue?vue&type=template&id=2d7184ed&scoped=true&"
import script from "./CustomerPropertiesSeparateList.vue?vue&type=script&lang=js&"
export * from "./CustomerPropertiesSeparateList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPropertiesSeparateList.vue?vue&type=style&index=0&id=2d7184ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7184ed",
  null
  
)

export default component.exports